export { default } from './FacetPlanProposalScenarioSelectionIntroPageTemplate';
